// extracted by mini-css-extract-plugin
module.exports = {"container":"_15y4TM","title":"rIxg7F","loginMsg":"_3-Ab6i","ctaButtons":"oq3rbY","loginRequired":"_2pMcCq","regTxt":"syFYrC","overlay":"_1IryHc"};